export const SET_PROPERTY_FILTER = 'SET_PROPERTY_FILTER';
export const SET_SELECTED_PROVINCE = 'SET_SELECTED_PROVINCE';
